var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49935 12.2222C7.49935 11.762 7.12625 11.3889 6.66602 11.3889C6.20578 11.3889 5.83268 11.762 5.83268 12.2222V13.6588C5.83268 14.0271 5.97901 14.3804 6.23948 14.6409L7.18787 15.5893C7.51331 15.9147 8.04095 15.9147 8.36638 15.5893C8.69182 15.2638 8.69182 14.7362 8.36638 14.4107L7.49935 13.5437V12.2222Z",
    fill: "#002CFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7216 17.7778H9.80898C8.95024 18.4727 7.85674 18.8889 6.66602 18.8889C3.90459 18.8889 1.66602 16.6503 1.66602 13.8889C1.66602 11.4114 3.46792 9.35476 5.83268 8.95803V5.27778C5.83268 3.59025 7.2007 2.22223 8.88824 2.22223H12.2216C12.4426 2.22223 12.6545 2.31003 12.8108 2.46631L17.533 7.18853C17.6893 7.34481 17.7771 7.55677 17.7771 7.77778V14.7222C17.7771 16.4098 16.4091 17.7778 14.7216 17.7778ZM7.49935 5.27778C7.49935 4.51072 8.12118 3.8889 8.88824 3.8889H11.3882V6.66667C11.3882 7.74056 12.2588 8.61112 13.3327 8.61112H16.1105V14.7222C16.1105 15.4893 15.4886 16.1111 14.7216 16.1111H11.1463C11.479 15.4417 11.666 14.6871 11.666 13.8889C11.666 11.4114 9.86411 9.35476 7.49935 8.95803V5.27778ZM14.9319 6.94445L13.0549 5.06741V6.66667C13.0549 6.82009 13.1793 6.94445 13.3327 6.94445H14.9319ZM6.66602 17.2222C8.50696 17.2222 9.99935 15.7298 9.99935 13.8889C9.99935 12.0479 8.50696 10.5556 6.66602 10.5556C4.82507 10.5556 3.33268 12.0479 3.33268 13.8889C3.33268 15.7298 4.82507 17.2222 6.66602 17.2222Z",
    fill: "#002CFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHistory);
export default __webpack_public_path__ + "static/media/iconHistory.f889d6928a490eecfabca686daa0d06e.svg";
export { ForwardRef as ReactComponent };